import css from 'styled-jsx/css'

import playerPlusLogo from '../../assets/images/STVPlayer+Logo.png'

export default css`
.ForceAdsWarning {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
}

.SvodExclusiveWarning {
    display: flex;
    align-items: center;
    padding: 3px 5px;
    gap: 4px;

    width: 61.65px;
    height: 19px;

    background: linear-gradient(270deg, #151515 25%, #9916C7 100%);
    /* Elevation Dark

    Elevation shadow on dark background
    */
    box-shadow: 0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3);
    border-radius: 3px;
}


.force-ads-text {
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;

    color: #FFFFFF;

    flex: none;
    order: 0;
    flex-grow: 0;

    vertical-align: middle;
    display: inline-block;

    filter: drop-shadow(0px 1px 2px #000000) drop-shadow(0px 1px 3px #000000);
}

.exclusive-logo {
    display: block;
    width: 56px;
    height: 15px;

    overflow: hidden;
    text-indent: 200%;
    white-space: nowrap;

    background-image: url(${playerPlusLogo});
    background-repeat: no-repeat;
    background-size: contain;
}

.logo-wrapper {
    background: linear-gradient(270deg, #151515 25%, #9916C7 100%);
    border-radius: 4px;
    gap: 4px;
}
.icon-wrapper { 
    filter: drop-shadow(0px 1px 2px #000000) drop-shadow(0px 1px 3px #000000);
}

.svod-exclusive-text {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;

    color: #FFFFFF;
}
`
